<div class="card card-body col-lg-12">
    <div class="row">
        <div class="col-lg-3 form-group">
            <legend class="mt-1 nocase">Counter Member Type<span class="red">*</span></legend>
            <div class="form-check form-check-inline">
                <input type="radio" formControlName="cntrMemType" name="cntrMemType" value="INTERBANK"
                    class="form-check-input" (change)="enableDropdown($event)"
                    [ngClass]="{'is-invalid': (counterPrtyData.cntrMemType.touched) && counterPrtyData.cntrMemType.errors}">
                <label class="form-check-label">Interbank</label>
            </div>
            <div class="form-check form-check-inline">
                <input type="radio" formControlName="cntrMemType" name="cntrMemType" value="CLIENT"
                    class="form-check-input" (change)="enableDropdown($event)"
                    [ngClass]="{'is-invalid': (counterPrtyData.cntrMemType.touched) && counterPrtyData.cntrMemType.errors}">
                <label class="form-check-label">Client</label>
            </div>
            <p *ngIf="counterPrtyData.cntrMemType.invalid && counterPrtyData.cntrMemType.touched" class="error nocase">
                Please select Counter Member Type
            </p>
        </div>
        <div *ngIf="counterPrtyData.cntrMemType.value=='INTERBANK'" class="col-lg-3 form-group">
            <label>Counter Party <span class="red">*</span></label>
            <select class="form-control form-control-sm selectpicker" formControlName="cntrMemId"
                title="Select Counter Party" data-live-search="true" (change)="selectCounterParty()"
                [ngClass]="{'is-invalid': (counterPrtyData.cntrMemId.touched) && counterPrtyData.cntrMemId.touched}">
                <option value="" disabled>Select Counter Party</option>
                <option *ngFor="let data of counterPartyData" value="{{data.entityCode}}">{{data.entityCode +" - "+data.userName}}</option>
            </select>
            <p *ngIf="counterPrtyData.cntrMemId.invalid && counterPrtyData.cntrMemId.touched" class="error nocase">
                Please select Counter Party
            </p>
        </div>
        <div *ngIf="counterPrtyData.cntrMemType.value=='CLIENT'" class="col-lg-3 form-group">
            <label>Client <span class="red">*</span></label>
            <select class="form-control form-control-sm selectpicker" formControlName="cntrMemId"
                title="Select Client" data-live-search="true" (change)="selectClient()"
                [ngClass]="{'is-invalid': (counterPrtyData.cntrMemId.touched) && counterPrtyData.cntrMemId.touched}">
                <option value="" disabled>Select Client</option>
                <option *ngFor="let data of clientData" value="{{data.clientID}}">{{data.clientLEICode +" - "+data.clientName}}</option>
            </select>
            <p *ngIf="counterPrtyData.cntrMemId.invalid && counterPrtyData.cntrMemId.touched" class="error nocase">
                Please select Client
            </p>
        </div>
        <div class="col-lg-3 form-group">
            <label>Counter Party LEI Code</label>
            <input type="text" class="form-control form-control-sm" formControlName="cntrPrtyLei" readonly>
        </div>
    </div>
</div>